import Model, { ID, IsoDateTime, MODEL_LEVEL } from 'src/models/model'
import TipPoolTip from 'src/models/tip/TipPoolTip'
import TipPoolType from 'src/models/tip/TipPoolType'

export default class TipPool extends Model {
  static name = 'TipPool'

  static level = MODEL_LEVEL.SITE

  static paginate = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Tipping]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      tipPoolType: {
        type: TipPoolType,
        default: null,
        output: true
      },
      tipPoolTips: {
        type: [TipPoolTip],
        default: () => ([]),
        output: true
      },
      state: {
        type: String,
        default: null,
        output: true
      },
      openedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      closedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      distributingAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      distributedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      }
    }

    this.computed = {
      amount () {
        return _.sumBy(this.tipPoolTips.data, 'amount')
      }
    }
  }
}
